import { cva } from 'class-variance-authority';

export { default as BaseButtonGroup } from './BaseButtonGroup.vue';

export const baseButtonGroupVariants = cva(
  'c-base-button-group',
  {
    variants: {
      variant: {
        default: 'c-base-button-group--left',
        center: 'c-base-button-group--center',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);
